import { CancelAffectedStaffResponse } from '../../lib/types/models/affectedStaff/affected-staff'
import { CancelAffectedStaffRequest } from '../../lib/types/models/affectedStaff/affected-staff-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelAffectedStaff(input: CancelAffectedStaffRequest) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.cancel.url, null))
    .post<CancelAffectedStaffResponse>(input)
}
